// Stream button click handler
const streamBtn = document.querySelector('.stream-text-btn');
if (streamBtn) {
    streamBtn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Stream button clicked');
        window.location.href = '/pages/stream';
    });
}

// Shop button click handler
const shopBtn = document.querySelector('.shop-text-btn');
if (shopBtn) {
    shopBtn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Shop button clicked');
        window.location.href = '/pages/shop';
    });
}

// Tour button click handler
const tourBtn = document.querySelector('.tour-text-btn');
if (tourBtn) {
    tourBtn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Tour button clicked');
        window.location.href = '/pages/tour';
    });
}

// About button click handler
const aboutBtn = document.querySelector('.about-text-btn');
if (aboutBtn) {
    aboutBtn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('About button clicked');
        window.location.href = '/pages/about';
    });
}

// Shop Now button click handler
const shopNowBtn = document.querySelector('.shop-now-btn');
if (shopNowBtn) {
    shopNowBtn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Shop Now button clicked');
        window.location.href = '/pages/shop';
    });
}

// Home button click handler
const homeBtn = document.querySelector('.home-text-btn');
if (homeBtn) {
    homeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Home button clicked');
        window.location.href = '/';
    });
}

// Click Here button 1 click handler
const clickHereBtn1 = document.querySelector('.click-here-btn');
if (clickHereBtn1) {
    clickHereBtn1.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Click Here button 1 clicked');
        window.open('https://www.youtube.com/watch?v=AhKAHoHgDfE', '_blank');
    });
}

// Click Here button 2 click handler
const clickHereBtn2 = document.querySelector('.click-here-btn-2');
if (clickHereBtn2) {
    clickHereBtn2.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Click Here button 2 clicked');
        window.open('https://open.spotify.com/album/0MNBsEYxVtmJNz42RTgosS?si=KSJEJWQvS3aUACkMyllqZA', '_blank');
    });
}

// Click Here button 3 click handler
const clickHereBtn3 = document.querySelector('.click-here-btn-3');
if (clickHereBtn3) {
    clickHereBtn3.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Click Here button 3 clicked - Shop page');
        window.location.href = '/pages/shop';
    });
}

// Skateboard image click handler
const skateboardImg = document.querySelector('.skateboard-img');
if (skateboardImg) {
    skateboardImg.addEventListener('click', function(e) {
        console.log('Skateboard image clicked');
        window.location.href = '/pages/shop';
    });
}

console.log('BLP KOSHER website loaded');
